import { createTheme } from '@mui/material/styles';
import { palette } from "./palette";
import { getOverrides } from "./overrides";

export const theme = createTheme({
    palette,
    components: getOverrides(),
});